<template>
  <span v-if="storageType == 'google_drive'">
    <i v-if="media.type == 'application/vnd.google-apps.shortcut' || media.type == 'application/vnd.google-apps.folder'" class="has-text-warning fa fa-folder fa-3x"></i>
    <i v-else-if="media.type == 'back'" class="has-text-info fa fa-folder-open fa-3x"></i>
    <figure v-else class="image" :class="size" style="overflow: hidden; margin: 0 auto;">
      <img style="width: 100%; height: 100%;" :src="`/assets/img/icon/${media_extension}.svg`"/>
    </figure>
  </span>
  <span v-else>
    <i v-if="media.file_type == 'folder'" class="has-text-warning fa fa-folder fa-3x"></i>
    <figure v-else-if="media.type == 'youtube'" class="image" :class="size" style="overflow: hidden; margin: 0 auto;">
      <img style="width: 100%; height: 100%;" :src="`/assets/img/icon/youtube.svg`"/>
    </figure>
    <figure v-else-if="media.type == 'image' && !isEmpty(media.thumb_url)" class="image" :class="size" style="overflow: hidden; margin: 0 auto;">
      <img :src="media.thumb_url"/>
    </figure>
    <i v-else-if="media.type == 'link'" class="has-text-grey fa fa-link fa-3x"></i>
    <figure v-else-if="media.type === 'other'" class="image" :class="size" style="overflow: hidden; margin: 0 auto;">
      <img v-if="['zip', 'rar'].indexOf(media.extension) > -1" style="width: 100%; height: 100%;" :src="`/assets/img/icon/${media_extension}.svg`"/>
      <img v-else style="width: 100%; height: 100%;" :src="`/assets/img/icon/${media.type}.svg`"/>
    </figure>
    <figure v-else class="image" :class="size" style="overflow: hidden; margin: 0 auto;">
      <img style="width: 100%; height: 100%;" :src="`/assets/img/icon/${media_extension}.svg`"/>
    </figure>
  </span>
</template>

<script>
  export default {
    props: {
      media: {
        type: Object,
        required: true
      },
      size: {
        type: String,
        default: 'is-48x48'
      },
      storageType: {
        type: String,
        default: 'cloud_storage'
      }
    },

    computed: {
      media_extension() {
        if (this.storageType == 'google_drive') {
          if (!this.isEmpty(this.media.fileExtension)) {
            return this.media.fileExtension.toLowerCase();
          }

          return 'other-icon';
        }
        return this.media.extension.toLowerCase();
      }
    }
  }
</script>
